<div class="mt-4 mx-6.5 mb-12">
  <scope-table
    [isTimeline]="isTimeline"
    [isEditable]="isEditable"
    [isChangeRequest]="!!currentChangeRequest"
    [currentUser]="currentUser"
    [scopeVersion]="scopeVersion"
    [feeMenuOptions]="feeMenuOptions"
    [currentRatecard]="currentRatecard"
    [mainColumnClass]="mainColumnClass"
    [componentMainColumnClass]="componentMainColumnClass"
    [roleMainColumnClass]="roleMainColumnClass"
    [sortedSections]="sortedSections"
    [sortedDefaultSectionDeliverables]="sortedDefaultSectionDeliverables"
    [cdnConfig]="cdnConfig"
    [deliverableMenuOptions]="deliverableMenuOptions"
    [componentMenuOptions]="componentMenuOptions"
    (onAddSectionFee)="onAddSectionFee.emit($event)"
    (onDeleteSection)="onDeleteSection.emit($event)"
    (onFetchDeliverable)="onFetchDeliverable.emit($event)"
    (onUpdateDeliverable)="onUpdateDeliverable.emit($event)"
    (onUpdateComponent)="onUpdateComponent.emit($event)"
    (onDeleteDeliverable)="onDeleteDeliverable.emit($event)"
    (onAcceptDeliverable)="onAcceptDeliverable.emit($event)"
    (onRejectDeliverable)="onRejectDeliverable.emit($event)"
    (onAddDeliverableFee)="onAddDeliverableFee.emit($event)"
    (onAddComponentFee)="onAddComponentFee.emit($event)"
    (onDeleteComponent)="onDeleteComponent.emit($event)"
    (onCompleteTrade)="onCompleteTrade.emit($event)"
    (onTradeDeliverable)="onTradeDeliverable.emit($event)"
    (onStopProgressTrade)="onStopProgressTrade.emit($event)"
    (onReopenTrade)="onReopenTrade.emit($event)"
    (onCancelTrade)="onCancelTrade.emit($event)"
    (onConfirmTrade)="onConfirmTrade.emit($event)"
    (onAddDeliverableToTrade)="onAddDeliverableToTrade.emit($event)"
    (onShowDeliverableApplyLocationCardDialog)="onShowDeliverableApplyLocationCardDialog.emit($event)"
    (onUpdateFeeItem)="onUpdateFeeItem.emit($event)"
    (onMoveDeliverable)="onMoveDeliverable.emit($event)"
    (onMoveComponent)="onMoveComponent.emit($event)"
    (onUpdateRole)="onUpdateRole.emit($event)"
    (onMoveComponentOutsideDeliverable)="onMoveComponentOutsideDeliverable.emit($event)" />

  <div class="mt-2 mx-3.5">
    <scope-ui-table
      [has-setting]="ApplicationSetting.FEE_ITEM__ENABLE + '&&' + ApplicationSetting.SCOPE__ENABLE_FEES"
      [has-privilege]="Privilege.SCOPE__VIEW_FEES"
      [loggedInUser]="currentUser"
      [tableClass]="'fees-table'"
      [headerExpandable]="true"
      [data]="scopeFees$ | async | orderBy: 'entity.id'"
      [displayedColumns]="scopeElementsService.scopeFeeColumns"
      [addToggleListColumn]="true"
      [noSort]="true"
      [noPagination]="true"
      [noPreferences]="true"
      [showAddButton]="
        (scopeApprovalFlowService.isScopeEditable(scopeVersion) || (currentChangeRequest && isEditable)) &&
        currentUser.hasPrivilege(Privilege.SCOPE__CREATE_FEES)
      "
      [expandable]="false"
      (addClicked)="addScopeFee()"
      [showToggleMenu]="feeMenuOptions?.length > 0"
      [menuOptions]="feeMenuOptions"
      (updateFeeItem)="updateFeeItem($event)"
      [showFooterRow]="true"
      [parentEntity]="scopeVersion"
      [convertCurrency]="exchangeRateService.selectedCurrency">
    </scope-ui-table>
  </div>

  <div class="wrapper font-newJuneBold mx-3.5">
    <div
      class="block-wrapper py-0"
      *ngIf="scopeVersion.discount"
      [has-privilege]="Privilege.SCOPE__VIEW_RATES"
      [has-privilege-entity]="scopeVersion">
      <div class="column ten--columns">
        <commentable
          [c-entity]="scopeVersion"
          [c-key]="'discountName'"
          [c-type]="'scope'"
          >{{ scopeVersion.discount.getDescription() }}
          {{
            scopeVersion.discount.getType() === 'PERCENTAGE'
              ? '(' + scopeVersion.discount.getValueFormatted() + '%)'
              : ''
          }}
        </commentable>
        <span class="grey m_top_5 f-style-builder">Discount</span>
      </div>
      <div class="column one--column center text-m">
        <commentable
          [c-entity]="scopeVersion"
          [c-key]="'discountValue'"
          [c-type]="'scope'">
          <span *ngIf="scopeVersion.hasPrivilege(Privilege.SCOPE__VIEW_RATES, currentUser)">
            {{ getDiscountValue(scopeVersion) | convertCurrency: exchangeRateService.selectedCurrency }}
          </span>
          <span *ngIf="!scopeVersion.hasPrivilege(Privilege.SCOPE__VIEW_RATES, currentUser)">--</span>
        </commentable>
      </div>

      <div class="column one--column">
        <div
          class="flex flex-row justify-end"
          [has-privilege]="
            (scopeVersion.identity.isTemplate ? Privilege.SCOPE_TEMPLATE__EDIT : Privilege.SCOPE_DISCOUNT__EDIT) +
            '&&' +
            Privilege.SCOPE__VIEW_RATES
          "
          *ngIf="
            scopeApprovalFlowService.isScopeEditable(scopeVersion) &&
            scopeVersion.hasPrivilegeValueRestriction(
              Privilege.SCOPE_DISCOUNT__EDIT,
              getDiscountValue(scopeVersion),
              currentUser
            )
          ">
          <button
            class="toggle-button ml-1"
            (click)="editDiscount()"
            mat-mini-fab>
            <mat-icon class="material-symbols-rounded">edit</mat-icon>
          </button>
          <button
            class="toggle-button ml-1"
            (click)="deleteDiscount()"
            mat-mini-fab>
            <mat-icon class="material-symbols-rounded">delete</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div
      class="block-wrapper py-0"
      *ngIf="scopeVersion.msaLineItem">
      <div class="column ten--columns">
        <commentable
          [c-entity]="scopeVersion"
          [c-key]="'msaLineItemName'"
          [c-type]="'scope'"
          >{{ scopeVersion.msaLineItem.getName() }}
          {{
            scopeVersion.msaLineItem.getType() === 'PERCENTAGE'
              ? '(' + scopeVersion.msaLineItem.getValueFormatted() + '%)'
              : ''
          }}
        </commentable>
        <span class="grey m_top_5 f-style-builder">MSA Line Item</span>
      </div>
      <div class="column one--column center text-m">
        <commentable
          [c-entity]="scopeVersion"
          [c-key]="'msaLineItemValue'"
          [c-type]="'scope'"
          >{{ scopeVersion.msaLineItem.chargeType === 'FEE' ? '' : '-' }}
          {{
            scopeVersion.msaLineItem.getType() === 'PERCENTAGE'
              ? (scopeVersion.msaLineItem.getValueByPercentage(
                  scopeVersion
                    .getTotalSellingPrice({ excludeFees: false, excludeMsa: true, excludeDiscount: false })
                    ?.getValue()
                ) | convertCurrency: exchangeRateService.selectedCurrency)
              : (scopeVersion.msaLineItem.getValueFormatted() | convertCurrency: exchangeRateService.selectedCurrency)
          }}
        </commentable>
      </div>

      <div class="column one--column">
        <div
          class="flex flex-row justify-end"
          [has-privilege]="Privilege.MSA_LINE_ITEM__EDIT"
          *ngIf="scopeApprovalFlowService.isScopeEditable(scopeVersion)">
          <button
            class="toggle-button ml-1"
            (click)="editMsaLineItem()"
            mat-mini-fab>
            <mat-icon class="material-symbols-rounded">edit</mat-icon>
          </button>
          <button
            class="toggle-button ml-1"
            (click)="deleteMsaLineItem()"
            mat-mini-fab>
            <mat-icon class="material-symbols-rounded">delete</mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div
      class="block-wrapper light-purple"
      [has-setting]="ApplicationSetting.SOW__RETAINED_HOURS"
      *ngIf="!scopeVersion.isScopeByRole() && scopeVersion.scopeOfWorkVersion && showUseRetainedTeamToggle">
      <div class="column nine--columns">
        <commentable
          [c-entity]="scopeVersion"
          [c-key]="'RetainedTeamLabel'"
          class="purple"
          [c-type]="'scope'">
          Retained Hours used {{ isUseRetainedHours() ? ' (On)' : ' (Off)' }}</commentable
        >
      </div>
      <div class="column one--column">
        <div
          class="purple"
          *ngIf="scopeVersion.useRetainedHours && scopeRetainedHoursStats">
          {{ scopeRetainedHoursStats.totalHours | formatHours }}
        </div>
      </div>
      <div class="column one--column">
        <div
          class="purple"
          *ngIf="scopeVersion.useRetainedHours && scopeRetainedHoursStats">
          {{ scopeRetainedHoursStats.totalSellingPrice.amount | convertCurrency: exchangeRateService.selectedCurrency }}
        </div>
      </div>
      <div class="column one--column">
        <mat-checkbox
          [disabled]="scopeVersion.status !== 'DRAFT'"
          value="{{ scopeVersion.useRetainedHours }}"
          [checked]="scopeVersion.useRetainedHours"
          (change)="updateUseRetainedHours($event)"
          aria-label="Use Retained Hours"></mat-checkbox>
      </div>
    </div>

    <div
      class="block-wrapper light-purple"
      [has-setting]="ApplicationSetting.SCOPE__MARGIN_SHOW"
      [has-privilege]="Privilege.SCOPE_MARGIN__VIEW">
      <div class="column nine--columns">
        <commentable
          [c-entity]="scopeVersion"
          [c-key]="'scopeMarginLabel'"
          class="purple"
          [c-type]="'scope'">
          {{ 'scope' | lang }} Margin
        </commentable>
      </div>
      <div class="column one--column">
        <div
          class="purple"
          [has-privilege]="Privilege.SCOPE_MARKUP__VIEW"
          matTooltip="Margin">
          <ng-container
            *ngTemplateOutlet="
              fieldDifference;
              context: {
                fieldName: 'scopeMarginPercentage',
                valueFn: formatPercentage,
                defaultValue: scopeVersion.getMarginPercentage(),
              }
            ">
          </ng-container>
        </div>
      </div>
      <div class="column one--column">
        <div
          class="purple"
          [has-privilege]="Privilege.SCOPE_MARKUP__VIEW"
          matTooltip="Profit">
          <ng-container
            *ngTemplateOutlet="
              fieldDifference;
              context: {
                fieldName: 'totalProfit',
                valueFn: formatPrice,
                defaultValue: scopeVersion.getTotalProfit()?.amount,
              }
            ">
          </ng-container>
        </div>
      </div>
      <div class="column one--column"></div>
    </div>

    <div class="block-wrapper dark-purple white">
      <div
        class="column flex items-center"
        [ngClass]="scopeElementsService.calculateScopeTotalsMainColumnClass(scopeVersion)">
        <commentable
          class="inline-block"
          [c-entity]="scopeVersion"
          [c-key]="'scopeTotalLabel'"
          [c-type]="'scope'"
          >{{ 'scope' | lang }} Totals</commentable
        >
        <button
          *ngIf="scopeApprovalFlowService.isScopeEditable(scopeVersion) && !scopeVersion.discount"
          [has-privilege]="
            (scopeVersion.identity.isTemplate ? Privilege.SCOPE_TEMPLATE__EDIT : Privilege.SCOPE_DISCOUNT__EDIT) +
            '&&' +
            Privilege.SCOPE__VIEW_RATES
          "
          type="button"
          class="primary ml-4"
          (click)="addDiscount()">
          Add discount
        </button>
      </div>

      <div
        class="column one--column"
        [has-privilege]="Privilege.SCOPE_MARKUP__VIEW"
        [has-privilege-entity]="scopeVersion"
        [hidden]="!scopeElementsService.userColumns.MARK_UP.selected">
        <ng-container
          *ngTemplateOutlet="
            fieldDifference;
            context: {
              highlight: true,
              fieldName: 'markup',
              valueFn: formatPercentage,
              defaultValue: scopeVersion.getMarkup(),
            }
          ">
        </ng-container>
      </div>

      <div
        class="column one--column"
        [has-privilege]="Privilege.SCOPE_MARKUP__VIEW"
        [has-privilege-entity]="scopeVersion"
        [hidden]="!scopeElementsService.userColumns.PROFIT.selected">
        <ng-container
          *ngTemplateOutlet="
            fieldDifference;
            context: {
              highlight: true,
              fieldName: 'totalProfit',
              valueFn: formatPrice,
              defaultValue: scopeVersion.getTotalProfit()?.amount,
            }
          ">
        </ng-container>
      </div>

      <div
        class="column one--column"
        [hidden]="!scopeElementsService.userColumns.SCOPEMARK_HOURS.selected">
        <commentable
          [c-entity]="scopeVersion"
          [c-key]="'scopeTotalSMHours'"
          [c-type]="'scope'">
          {{ scopeVersion.getCachedTotalScopeMarkHours() | formatHours }}
        </commentable>
      </div>

      <div
        class="column one--column"
        [hidden]="!scopeElementsService.userColumns.SCOPEMARK_PRICE.selected">
        <commentable
          [c-entity]="scopeVersion"
          [c-key]="'scopeTotalSMPrice'"
          [c-type]="'scope'">
          <span
            [has-privilege]="Privilege.SCOPE__VIEW_RATES"
            [has-privilege-mask]="'--'"
            [has-setting]="ApplicationSetting.RATECARD__SCOPEMARK__RATES"
            [has-setting-disabled-mask]="'--'">
            {{
              scopeVersion.totalScopeMarkSellingPrice()
                ? (scopeVersion.totalScopeMarkSellingPrice().amount
                  | convertCurrency: exchangeRateService.selectedCurrency)
                : '--'
            }}
          </span>
        </commentable>
      </div>

      <div
        class="column one--column"
        [hidden]="!scopeElementsService.userColumns.AGENCY_HOURS.selected">
        <commentable
          [c-entity]="scopeVersion"
          [c-key]="'scopeTotalRateCardHours'"
          [c-type]="'scope'">
          <span
            [has-setting]="ApplicationSetting.SCOPE__AGENCY_HOURS"
            [has-setting-disabled-mask]="'--'">
            <ng-container
              *ngTemplateOutlet="
                fieldDifference;
                context: {
                  highlight: true,
                  fieldName: 'totalRateCardHours',
                  valueFn: formatHours,
                  defaultValue: scopeVersion.getTotalRateCardHours(),
                }
              ">
            </ng-container>
          </span>
        </commentable>
      </div>

      <div
        class="column one--column"
        [hidden]="!scopeElementsService.userColumns.BUDGET.selected">
        <commentable
          [c-entity]="scopeVersion"
          [c-key]="'scopeTotalDeliverableBudget'"
          [c-type]="'scope'">
          <span
            [has-privilege]="Privilege.SCOPE__VIEW_RATES"
            [has-privilege-mask]="'--'"
            matTooltip="Allocated budget of {{
              getTotalDeliverableBudget() | convertCurrency: exchangeRateService.selectedCurrency
            }} exceeds scope budget of  {{
              scopeVersion.budget?.amount | convertCurrency: exchangeRateService.selectedCurrency
            }}"
            [matTooltipDisabled]="scopeVersion.budget?.amount <= getTotalDeliverableBudget()">
            <ng-container
              *ngTemplateOutlet="
                fieldDifference;
                context: {
                  highlight: true,
                  fieldName: 'deliverableBudgetTotal',
                  valueFn: formatPrice,
                  defaultValue: scopeVersion.getTotalDeliverableBudget()?.amount,
                }
              ">
            </ng-container>
          </span>
        </commentable>
      </div>
      <div
        class="column one--column"
        [hidden]="!scopeElementsService.userColumns.BALANCE.selected">
        <commentable
          [c-entity]="scopeVersion"
          [c-key]="'scopeTotalBudgetBalance'"
          [c-type]="'scope'">
          <span
            matTooltip="Over {{ 'scope' | lang }} budget of {{
              scopeVersion.budget?.amount | convertCurrency: exchangeRateService.selectedCurrency
            }}"
            [matTooltipDisabled]="getBudgetBalance() >= 0"
            [has-privilege]="Privilege.SCOPE__VIEW_RATES"
            [has-privilege-mask]="'--'"
            [ngClass]="{ 'highlight-error': getBudgetBalance() < 0 }">
            <ng-container
              *ngTemplateOutlet="
                fieldDifference;
                context: {
                  highlight: true,
                  fieldName: 'budgetBalance',
                  valueFn: formatPrice,
                  defaultValue: scopeVersion.getBudgetBalance().amount,
                }
              ">
            </ng-container>
          </span>
        </commentable>
      </div>
      <div
        class="column one--column"
        [hidden]="!scopeElementsService.userColumns.AGENCY_PRICE.selected">
        <commentable
          [c-entity]="scopeVersion"
          [c-key]="'scopeTotalRateCardPrice'"
          [c-type]="'scope'">
          <span
            [has-privilege]="Privilege.SCOPE__VIEW_RATES"
            [has-privilege-mask]="'--'"
            *ngIf="!scopeVersion.containsUnmappedScopeMarkRoles">
            <ng-container
              *ngTemplateOutlet="
                fieldDifference;
                context: {
                  highlight: true,
                  fieldName: 'totalSellingPrice',
                  valueFn: formatPrice,
                  defaultValue: scopeVersion.getTotalSellingPrice()?.amount,
                }
              ">
            </ng-container>
          </span>
          <span *ngIf="scopeVersion.containsUnmappedScopeMarkRoles"> -- </span>
        </commentable>
      </div>
      <div class="column one--column"></div>
    </div>

    <div
      class="block-wrapper dark-purple white"
      *ngIf="scopeElementsService.userColumns.SCOPE__TRAFFICKING__DELIVERABLE_ACTUALS.selected">
      <div class="column ten--columns">
        <p class="flex items-center">
          <span class="mr-2">Total Complete Percentage:</span>
          <ng-container
            *ngTemplateOutlet="
              fieldDifference;
              context: {
                highlight: true,
                fieldName: 'totalPercentageComplete',
                valueFn: formatPercentage,
                defaultValue: scopeVersion.totalPercentageComplete(),
              }
            ">
          </ng-container>
        </p>
      </div>
      <div class="column two--columns">
        <p class="flex items-center justify-end">
          <span class="mr-2">Total Actuals:</span>
          <ng-container
            *ngTemplateOutlet="
              fieldDifference;
              context: {
                highlight: true,
                fieldName: 'totalActualHours',
                valueFn: formatHours,
                defaultValue: scopeVersion.totalActualHours(),
              }
            ">
          </ng-container>
        </p>
      </div>
    </div>
  </div>
</div>

<ng-template
  #fieldDifference
  let-fieldName="fieldName"
  let-valueFn="valueFn"
  let-defaultValue="defaultValue"
  let-highlight="highlight">
  <scope-field-difference
    [isChangeRequest]="!!currentChangeRequest"
    [highlightColors]="highlight"
    [fieldName]="fieldName"
    [defaultValue]="defaultValue"
    [changes]="scopeVersion.changes"
    [getFieldToDisplay]="getFieldToDisplay"
    [showDiff]="showDiff"
    [valueFn]="valueFn" />
</ng-template>
